// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__m7iF1","content":"Modal_content__xLJxr","show":"Modal_show__je7re","backdrop":"Modal_backdrop__+CAwu"};